// 统一请求路径前缀在libs/axios.js中修改
import {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    uploadFileRequest,
    postFileRequest,
    getFileRequest,
} from "@/libs/axios";

// 学习计划分类-tree数据
export const selectTreeData = (params) => {
    return postRequest("/base/learnGroup/list", params);
};
//学习计划分类-更新
export const editPlanGroup = (params) => {
    return postRequest("/base/learnGroup/add", params);
};

//学习计划分类-删除
export const delPlanGroup = (params) => {
    return postRequest("/base/learnGroup/delByIds", params);
};
//学习计划-添加
export const addPlan = (params) => {
    return postRequest("/base/learnPlan/add", params);
};
//学习计划-分页
export const planPageList = (params) => {
    return postRequest("/base/learnPlan/pageList", params);
};
//学习计划-详情
export const planDetail = (params) => {
    return postRequest("/base/learnPlan/get", params);
};



